<template>
    <div class="dashboard">       
      <Sidebar/>
      <div class="page">
        <!-- <Toolbar /> -->
        <div class="content dashboard superAdmin">
          <div class="container container-super-admin">
            <!-- Título -->
            <div class="section-title">
              <h4>Aprovações</h4>
              <p>Lista de clientes para aprovação de vendas</p>
            </div>

            <div class="container-inner" v-if="hasReady">
              <!-- Filtros -->
              <div class="filters-container">
                <div class="filter-group">
                  <label>Nome</label>
                  <input 
                    type="text" 
                    v-model="searchTerm" 
                    @input="onSearch"
                    placeholder="Digite o nome da empresa..."
                    class="filter-input"
                  />
                </div>
                <div class="filter-group">
                  <label>CNPJ</label>
                  <input 
                    type="text" 
                    v-model="searchCnpj" 
                    @input="onSearch"
                    placeholder="Digite o CNPJ..."
                    class="filter-input"
                  />
                </div>
                <div class="filter-group">
                  <label>Sistema</label>
                  <select v-model="selectedType" @change="filterByType" class="filter-select">
                    <option value="">Todos</option>
                    <option value="1">Weeduc</option>
                    <option value="2">Weflix</option>
                  </select>
                </div>
                <div class="filter-group">
                  <label>Status</label>
                  <select v-model="selectedStatus" @change="onSearch" class="filter-select">
                    <option value="">Todos</option>
                    <option value="0">Pendente</option>
                    <option value="1">Aprovado</option>
                  </select>
                </div>
              </div>

                <table class="table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nome</th>
                            <th class="companyListSuperAdmin">CNPJ</th>
                            <th>Sistema</th>
                            <th>Telefone</th>
                            <th>E-mail</th>
                            <th>Status Venda</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody> 
                        <tr v-for="company in paginatedCompanies" :key="company.id">
                            <td>{{company.id}}</td>
                            <td>{{company.name}}</td>
                            <td class="companyListSuperAdmin">{{company.idFiscal ? company.idFiscal.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5") : ''}}</td>
                            <td>{{company.typeSystem == 1 ? 'Weeduc' : 'Weflix'}}</td>
                            <td>{{company.phone ? company.phone.replace(/^(\d{2})(\d{4,5})(\d{4})$/, "($1) $2-$3") : ''}}</td>
                            <td>{{company.email || '-'}}</td>
                            <td>
                              <span :class="company.cartStatus == 1 ? 'status-approved' : 'status-pending'">
                                {{company.cartStatus == 1 ? 'Aprovado' : 'Pendente'}}
                              </span>
                            </td>
                            <td class="actions-cell">
                              <button 
                                v-if="company.cartStatus != 1"
                                @click="approveSale(company.id)"
                                class="btn-approve"
                                :disabled="loadingApproval === company.id"
                                title="Aprovar venda"
                              >
                                <fa v-if="loadingApproval !== company.id" icon="fa-solid fa-check" />
                                <span v-else class="spinner"></span>
                                Aprovar Venda
                              </button>
                              <span v-else class="status-badge approved">Venda Aprovada</span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="pagination">
                  <button 
                    :disabled="currentPage === 1"
                    @click="currentPage--"
                    class="pagination-btn"
                  >
                    Anterior
                  </button>
                  <span>Página {{currentPage}} de {{totalPages}}</span>
                  <button 
                    :disabled="currentPage === totalPages"
                    @click="currentPage++"
                    class="pagination-btn"
                  >
                    Próxima
                  </button>
                </div>
            </div>
          </div>
        </div>
        <Loader :hasReady="hasReady"/>
      </div>
      <Footer/>
    </div>
  </template>
  
  <script>
    import Sidebar from '@/components/Weflix/Sidebar-SuperAdmin.vue'
    import Footer from '@/components/Admin/Footer/footerSuperAdmin.vue'
    import { mapState, mapActions } from 'vuex';
    import superAdmin from '@/utils/superAdmin';
    import Loader from '@/components/Weflix/Loader.vue';

  
    export default {
      data() {
        return {
          listCompanys: [],
          selectedType: '',
          selectedStatus: '',
          searchTerm: '',
          searchCnpj: '',
          hasReady: false,
          currentPage: 1,
          itemsPerPage: 10,
          loadingApproval: null
        }
      },
      components: {
        Sidebar,
        Footer,
        Loader
      },
      computed: {
        ...mapState(['token']),
        filteredCompanys() {
          let filtered = this.listCompanys;
          
          // Filtro por sistema
          if (this.selectedType) {
            filtered = filtered.filter(company => company.typeSystem == this.selectedType);
          }
          
          // Filtro por status
          if (this.selectedStatus !== '') {
            filtered = filtered.filter(company => company.cartStatus == this.selectedStatus);
          }
          
          // Filtro por nome
          if (this.searchTerm && this.searchTerm.trim() !== '') {
            const search = this.searchTerm.toLowerCase().trim();
            filtered = filtered.filter(company => 
              company.name && company.name.toLowerCase().includes(search)
            );
          }
          
          // Filtro por CNPJ
          if (this.searchCnpj && this.searchCnpj.trim() !== '') {
            const search = this.searchCnpj.replace(/[^\d]/g, ''); // Remove formatação
            filtered = filtered.filter(company => {
              if (!company.idFiscal) return false;
              const cnpj = company.idFiscal.replace(/[^\d]/g, '');
              return cnpj.includes(search);
            });
          }
          
          return filtered;
        },
        paginatedCompanies() {
          const start = (this.currentPage - 1) * this.itemsPerPage;
          const end = start + this.itemsPerPage;
          return this.filteredCompanys.slice(start, end);
        },
        totalPages() {
          return Math.ceil(this.filteredCompanys.length / this.itemsPerPage);
        }
      },
      methods: {
        async listCompany(){
          try {
            this.hasReady = false;
            const response = await superAdmin.listCompany(this.token);
            this.listCompanys = response;
            this.hasReady = true;
          } catch (error) {
            console.error(error);
            this.hasReady = true;
          }
        },
        async approveSale(companyId) {
          try {
            this.loadingApproval = companyId;
            await superAdmin.approveSale(this.token, companyId);
            
            // Atualiza o status localmente
            const company = this.listCompanys.find(c => c.id === companyId);
            if (company) {
              company.cartStatus = 1;
            }
            
            this.$toast?.success('Venda aprovada com sucesso!');
          } catch (error) {
            console.error('Erro ao aprovar venda:', error);
            this.$toast?.error('Erro ao aprovar venda. Tente novamente.');
          } finally {
            this.loadingApproval = null;
          }
        },
        filterByType() {
          this.currentPage = 1;
        },
        onSearch() {
          this.currentPage = 1;
        }
      },
      created() {
        this.listCompany();
      }
    }
  </script>
  <style scoped>
  select:focus-visible {
    border: none !important;
    outline: none;
  }
  </style>
  <style>
    .flex {
      display: flex;
      align-items: flex-start;
      gap: 0px;
      flex-wrap: wrap;
    }
    .dashboard {
      display: flex;
      flex-direction: column;
      height: 100%;
      background-color: #eef0fc;
      margin: 0;
      position: relative;
    }   
    .content.dashboard {
      background-color: transparent;
      margin: 0;
      width: 100%;
      padding: 10px 10px;
      height: 100%;
    }
    .col-form-inner {
      padding: 0px;
  }
  .form-group {
      margin: 5px 10px;
  }
  textarea {
      height: 120px;
      font-family: "Poppins";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 28px;
      resize: none;
      outline: none;
      padding: 0.5rem 0.75rem;
      color: #5f5f5f;
      background-color: #fff;
      border: 1px solid #dbdcde;
      box-shadow: none;
      width: 100%;
      border-radius: 5px;
  }
  button.btn_new {
      color: #250891;
      width: 20%;
      background-color: #ffffff;
      padding: 6px 10px;
      border-radius: 5px;
      transition: all 500ms ease-in-out;
      font-size: 18px;
      border: 1px solid #250891;
  }
  .content.dashboard.superAdmin {
      margin-bottom: 70px;
  }
  hr {
      width: 95%;
      margin: 25px auto;
  }
  span.iconCopy {
      position: absolute;
      top: 10px;
      right: 5px;
      cursor: pointer;
      z-index: 9;
  }
  svg.svg-inline--fa.fa-check {
      color: green;
  }
  svg.svg-inline--fa.fa-xmark {
      color: white;
  }
  .container {
      padding: 10px;
  }
  .container.container-super-admin {
      width: 84%;
      left: 15.5%;
      position: absolute;
      max-width: 100%;
      background-color: #ffffff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      padding: 30px;
      margin-top: 20px;
      margin-bottom: 40px;
  }

  .container.container-super-admin .container-inner {
      padding: 0;
      margin: 0;
      background-color: transparent;
      box-shadow: none;
      border-radius: 0;
  }

  .container.container-super-admin .section-title {
      margin: 0 0 30px 0;
      padding-bottom: 15px;
      border-bottom: 2px solid #e8e8e8;
      text-align: left;
  }

  .container.container-super-admin .section-title h4 {
      font-size: 1.25rem;
      font-weight: 700;
      color: #1a1a1a;
      margin: 0 0 6px 0;
      line-height: 1.3;
      text-align: left;
  }

  .container.container-super-admin .section-title p {
      font-size: 0.875rem;
      color: #6b7280;
      margin: 0;
      line-height: 1.5;
      text-align: left;
  }

  .container.container-super-admin .filters-container {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 20px;
      margin-bottom: 25px;
      padding: 20px;
      background-color: #f8fafc;
      border-radius: 8px;
      border: 1px solid #e5e7eb;
  }

  .container.container-super-admin .filter-group {
      display: flex;
      flex-direction: column;
      gap: 8px;
  }

  .container.container-super-admin .filter-group label {
      font-size: 0.875rem;
      font-weight: 600;
      color: #374151;
  }

  .container.container-super-admin .filter-input,
  .container.container-super-admin .filter-select {
      width: 100%;
      padding: 10px 14px;
      font-size: 0.875rem;
      color: #1a1a1a;
      background-color: #ffffff;
      border: 1px solid #d1d5db;
      border-radius: 6px;
      transition: all 0.2s ease;
      box-sizing: border-box;
  }

  .container.container-super-admin .filter-input:focus,
  .container.container-super-admin .filter-select:focus {
      outline: none;
      border-color: #250891;
      box-shadow: 0 0 0 3px rgba(37, 8, 145, 0.1);
  }

  .container.container-super-admin .filter-select {
      appearance: none;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23374151' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 12px center;
      padding-right: 36px;
  }

  .container.container-super-admin .table {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      background-color: #ffffff;
      margin-top: 0;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  .container.container-super-admin .table thead {
      background-color: #f8fafc;
  }

  .container.container-super-admin .table th {
      padding: 14px 16px;
      font-weight: 600;
      color: #374151;
      text-align: left;
      border-bottom: 2px solid #e5e7eb;
      font-size: 0.875rem;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      white-space: nowrap;
  }

  .container.container-super-admin .table th:first-child {
      padding-left: 20px;
  }

  .container.container-super-admin .table th:last-child {
      padding-right: 20px;
      text-align: center;
  }

  .container.container-super-admin .table td {
      padding: 14px 16px;
      vertical-align: middle;
      border-bottom: 1px solid #f3f4f6;
      color: #1f2937;
      font-size: 0.875rem;
      background-color: #ffffff;
      transition: background-color 0.2s ease;
  }

  .container.container-super-admin .table td:first-child {
      padding-left: 20px;
      font-weight: 600;
      color: #6b7280;
  }

  .container.container-super-admin .table td:last-child {
      padding-right: 20px;
      text-align: center;
  }

  .container.container-super-admin .table tbody tr {
      transition: all 0.2s ease;
  }

  .container.container-super-admin .table tbody tr:hover {
      background-color: #f9fafb;
  }

  .container.container-super-admin .table tbody tr:hover td {
      background-color: #f9fafb;
  }

  .container.container-super-admin .table tbody tr:last-child td {
      border-bottom: none;
  }

  .container.container-super-admin .table .actions-cell {
      text-align: center;
  }

  .container.container-super-admin .table .btn-approve {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      padding: 8px 16px;
      background-color: #10b981;
      color: white;
      border: none;
      border-radius: 6px;
      font-size: 0.875rem;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;
  }

  .container.container-super-admin .table .btn-approve:hover:not(:disabled) {
      background-color: #059669;
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(16, 185, 129, 0.3);
  }

  .container.container-super-admin .table .btn-approve:disabled {
      background-color: #9ca3af;
      cursor: not-allowed;
      opacity: 0.7;
  }

  .container.container-super-admin .table .status-badge {
      display: inline-block;
      padding: 6px 12px;
      border-radius: 6px;
      font-size: 0.75rem;
      font-weight: 600;
      text-transform: uppercase;
  }

  .container.container-super-admin .table .status-badge.approved {
      background-color: #d1fae5;
      color: #065f46;
  }

  .container.container-super-admin .table .status-approved {
      color: #059669;
      font-weight: 600;
  }

  .container.container-super-admin .table .status-pending {
      color: #f59e0b;
      font-weight: 600;
  }

  .container.container-super-admin .table .spinner {
      display: inline-block;
      width: 14px;
      height: 14px;
      border: 2px solid rgba(255, 255, 255, 0.3);
      border-radius: 50%;
      border-top-color: white;
      animation: spin 0.6s linear infinite;
  }

  @keyframes spin {
      to { transform: rotate(360deg); }
  }

  .container.container-super-admin .pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      margin-top: 30px;
      padding-top: 20px;
      border-top: 2px solid #e8e8e8;
  }

  .container.container-super-admin .pagination-btn {
      padding: 10px 20px;
      border: 1px solid #250891;
      border-radius: 6px;
      background: white;
      color: #250891;
      cursor: pointer;
      font-size: 0.875rem;
      font-weight: 500;
      transition: all 0.3s ease;
  }

  .container.container-super-admin .pagination-btn:hover:not(:disabled) {
      background-color: #250891;
      color: white;
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(37, 8, 145, 0.2);
  }

  .container.container-super-admin .pagination-btn:disabled {
      border-color: #d1d5db;
      color: #9ca3af;
      cursor: not-allowed;
      background: #f9fafb;
  }

  .container.container-super-admin .pagination span {
      font-size: 0.875rem;
      color: #6b7280;
      font-weight: 500;
  }

  /* Responsividade */
  @media (max-width: 1200px) {
      .container.container-super-admin {
          width: 90%;
          left: 10%;
          padding: 25px;
      }
      
      .container.container-super-admin .filters-container {
          grid-template-columns: repeat(2, 1fr);
      }
  }
  
  @media (max-width: 992px) {
      .container.container-super-admin .filters-container {
          grid-template-columns: repeat(2, 1fr);
      }
  }

  @media (max-width: 768px) {
      .container.container-super-admin {
          width: 100%;
          left: 0;
          padding: 20px;
          margin-top: 10px;
          border-radius: 0;
      }
      
      .container.container-super-admin .filters-container {
          grid-template-columns: 1fr;
          gap: 15px;
          padding: 15px;
      }
      
      .container.container-super-admin .table {
          font-size: 0.75rem;
          display: block;
          overflow-x: auto;
      }
      
      .container.container-super-admin .table th,
      .container.container-super-admin .table td {
          padding: 10px 8px;
      }
  }
  </style>
  <style scoped>
    @media (max-width: 600px) {
      .container {
        overflow-y: auto;
      }
      .companyListSuperAdmin {
        display: none;
      }
    }
  </style>

